import React, { Component, useEffect } from 'react';
import './App.scss';
import './fonts/fonts.css';
import { SearchForm } from "./search_form/search_form.js";
import getQuery from './generic_query.js'
import SrpList from './search_results_page/srp_list';
import SrpMap from './map/srp_map.js'
import Loader from 'react-loader-spinner'
import DetailModal from './detail/detail_modal.js'
import FloorplanModal from './detail/floorplan_modal.js'
import ShareModal from './detail/share_modal.js'
import Toggle from './util/toggle.js'
import adiTrack from './util/adi_track'
import { getUrlParams2, trackBDX } from './util/util'

const defaults = require('./defaults');
const origin = window.location.origin;
const apiGateway = origin.includes("localhost") || origin.includes("-dev") ? "0uncga59k7" : "nwepeeyoic";
const elastic_endpoint = `https://${apiGateway}.execute-api.us-east-1.amazonaws.com/v1/current/`;
const getUrlParams = () => (getUrlParams2(window));

const App = () => {
    return (
      <div className="re">
        <header>
        </header>
        <Srp />
      </div>
    );
}

class Srp extends Component {

    constructor(props) {
        super(props)
        this.windowInfo = this.getWindowInfo();
        this.state = {
            modalIsOpen: false,
            floorplanModalIsOpen: false,
            floorplanURL: '',
            shareModalIsOpen: false,
            item: {},
            itemKey: this.windowInfo.detailItemKey || null,
            filters: null,
            results: null,
            changed: false,
            mapSearch: false,
            showMap: this.windowInfo.defaultMapView,
            viewStateMapBounds: null,
            initialPageLoad: true,
            listingCount: '',
            page: 0,
            maxResults: 30,
            url: window.location.href,
        };
    }

    fullName = window.location.host.indexOf("localhost") !== 0
        ? window.location.host.split(".")[1]
        : getUrlParams(window)["aff"]
            ? getUrlParams(window)['aff']
            : "syracuse";

    affiliateShortName = () => {
        const modified = {
        "al": "bama",
        "cleveland": "cleve",
        "lehighvalleylive": "lvlive",
        "oregonlive": "olive",
        "pennlive": "penn",
        "masslive": "mass",
        "syracuse": "syr",
        "gulflive": "gulf",
        }[this.fullName];
        return modified ? modified : this.fullName;
    }

    getWindowInfo = () => {
        const affiliate = "RE_" + this.affiliateShortName();
        const detailItemKey = getUrlParams().detail_page || null;
        //if defaultMapView is set to true, and not using mobile device
        const defaultMapView = defaults[this.affiliateShortName()].defaultMapView === false || (window.innerWidth <= 800) ? false : true;
        const showAdTile = defaults[this.affiliateShortName()].hideAds===true ? false : true
        return {affiliate, detailItemKey, defaultMapView, showAdTile};
    }

    clickShareModal = () => {
        const shareModalIsOpen = !this.state.shareModalIsOpen
        this.setState({
            shareModalIsOpen: shareModalIsOpen
        });
    }

    clickFloorplanModal = (floorplanURL) => {
        const floorplanModalIsOpen = !this.state.floorplanModalIsOpen
        const modalURL = floorplanURL || ''
        this.setState({
            floorplanModalIsOpen: floorplanModalIsOpen,
            floorplanURL: modalURL
        });
    }

    clickModal = (item, itemKey) => {
        if (item && item.property
            && (item.property.includes("_BHI") || item.property.includes("_FORECLOSURES"))) {
            //for BDX listing, open in new tab and track traffic
            if (item.property.includes("_BHI")) trackBDX(item.ad_number,this.fullName, "Click");
            if (item.detail_url) {
                window.open(item.detail_url.replace("&#58;", ":"), '_blank');
            }
        } else {
            const modalIsOpen = !this.state.modalIsOpen;
            const modalItemKey = itemKey || null;
            const modalItem = item ? item : {};
            const modalQueryParams = this.state.filters;
            let urlString = this.getUrlBase() + modalQueryParams.urlString;

            urlString = this.removeUrlNameValue(urlString, 'detail_page');
            if (modalIsOpen) {
                urlString += '&detail_page=' + modalItemKey;
                adiTrack.page(urlString);
                if (window.AdManager) {
                    window.AdManager.injectUnit([
                        { position: 'InContent_Center', container: 'InContent_Center' },
                        { position: 'RightRail_Bottom', container: 'RightRail_Bottom' }]);
                }
            }
            this.setState({
                modalIsOpen: modalIsOpen,
                item: modalItem,
                itemKey: modalItemKey,
                url: urlString
            });
            window.history.pushState({
                modalIsOpen: modalIsOpen,
                itemKey: itemKey,
                changed: false,
                url: urlString,
                results: this.state.results
            }, 'modalClick', urlString);
        }
    };

    removeUrlNameValue = (urlString, nameValue) => {
        const parts = urlString.split('&');
        let ret = '';
        for (let i=0; i < parts.length; i++) {
            if (parts[i].indexOf(nameValue) < 0) {
                ret += parts[i] + '&';
            }
        }
        if ( ret.indexOf('/?') < 0 ) ret = '/?' + ret;
        ret = ret.substring(0, ret.length -1);
        return ret;
    }

    getUrlBase = () => {
        // Account for realestate.foo.com/hash/search(/) case - if pathname ends with 'search/', proceed
        // If there is no trailing slash, append it
        let searchPath = window.location.pathname.replace(/search$/, 'search/');
        // Account for either realestate or localhost situations (localhost don't have to worry about path)
        return window.location.origin.includes('realestate') ?
            window.location.origin + searchPath + '?' : '/?';
    }

    getStateUrlParams = () => {
        let ret = {};
        this.state.url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
            ret[key] = value;
        });
        return ret;
    };
    searchUI() {
        const loader = window.document.querySelector('.loader');
        const prevNext = window.document.querySelectorAll('.prev-next');
        const start = () => {
            loader.classList.add('active');
            prevNext.forEach(e => e.classList.add('hidden'))
        }
        const complete = () => {
            loader.classList.remove('active');
            prevNext.forEach(e => e.classList.remove('hidden'))
        }
        return {start, complete}
    }

    getResults = (callback, mapBounds, pageDirection) => {
        /* callback: on end of load; e.g., hide loader UI */
        const {filters, itemKey, viewStateMapBounds, page, maxResults} = this.state;
        // console.log("Rendering filters:");
        // console.log(filters);
        let queryParams = Object.assign({}, this.windowInfo, filters);
        if (pageDirection) {
            if (pageDirection === 'increase') {
                queryParams.page = page + 1;
            } else {
                queryParams.page = page - 1;
            }
        } else {
            queryParams.page = 0;
        }
        this.setState({page: queryParams.page});
        this.setState({mapSearch: queryParams.mapSearch})
        if (mapBounds) {
            this.setState({viewStateMapBounds: mapBounds});
        }
        // need to retrieve queryMapBounds from viewStateMapBounds in case the search criteria was updated without refreshing map
        const queryMapBounds = mapBounds || viewStateMapBounds;
        if (queryParams.mapSearch && queryMapBounds) {
            queryParams.mapBounds = queryMapBounds;
            if (queryParams.geo) {
                queryParams.address = '';
                queryParams.geo.zip = '';
                if (queryParams.geo.ll_dist) {
                    queryParams.geo.ll_dist.lat = '';
                    queryParams.geo.ll_dist.lon = '';
                }
                if (queryParams.geo.city_state) {
                    queryParams.geo.city_state.city = '';
                    queryParams.geo.city_state.state = '';
                }
            }
        }

        let body = JSON.stringify(getQuery(queryParams));
        fetch(elastic_endpoint, {
            method: "POST",
            body: body
        }).then((response) => {
			return response.json();
        }).then((results) => {
            this.setState({results: results, changed: false});
            //console.log("Queryparams are");
            //console.log(queryParams);
            let urlString = this.getUrlBase() + queryParams.urlString;
            let urlParams = getUrlParams();
            if (!itemKey) urlString = this.removeUrlNameValue(urlString, 'detail_page');
            if (window.location.host.indexOf('localhost') !== -1 && urlParams['aff']) {
                urlString += "&aff=" + urlParams['aff']
            }
            if (!this.state.initialPageLoad) {
                adiTrack.page();
            }
			if (this.state.initialPageLoad) {
			    this.setState({initialPageLoad: false})
			    if (window.AdManager) window.AdManager.injectUnit([
			        {position: 'Window_Bottom', container: 'Window_Bottom'}]);
			}
			callback();
			this.setState({listingCount: this.displayListingCount(page, maxResults, results)});
            const detailItem = this.getDetailItemFromResults(results, itemKey);
            if (detailItem) { this.setState({item: detailItem, modalIsOpen: true}); }
            window.history.pushState({
                results: this.state.results,
                listingCount: this.state.listingCount,
                modalIsOpen: this.state.modalIsOpen,
                item: detailItem,
                itemKey: itemKey,
                url: urlString,
                changed: false
            }, 'results', urlString);
		});
    }
    getDetailItemFromResults(results, itemKey) {
        const myItems = results ? results._discovery.response.hits.hits : null;
        const detailItemFull = myItems ? myItems.find((item) => { return item._id === itemKey }) : null;
        return detailItemFull ? detailItemFull['_source'] : null;
    }
    displayListingCount(page, maxResults, results) {
        console.log(`RESULTS: `)
        console.log(results)
        const listings = results ? results._discovery.response.hits.hits : {};
        const totalListings = results ? results._discovery.response.hits.total.value : 0;
        const offset = results ? results._discovery.request.from : 0;
        const requestPage = offset / maxResults + 1;
        const lastResultShown = Math.min(totalListings, offset + maxResults);
        return totalListings
            ? 'Showing ' + (
                totalListings > maxResults
                    ? offset == 0
                        ? `${Object.keys(listings).length} of `
                        : `${offset + 1} to ${lastResultShown} of `
                    : ""
                ) +
                `${totalListings} total listings` +
                (!offset && totalListings > maxResults
                    ? ': add filters above to refine your search'
                    : '')
            : 'No properties found';
    }
    componentDidMount(){
        //  no initial call to sendQuery(): we call setState when the filter UI mounts so defaults are reflected
        window.onpopstate = () => {
            console.log("got a pop");
            console.log(window.history.state);
            // We've reached the start, send them back to a previous page
            if (window.history.state === null) {
                console.log("Bye Bye!!");
                window.history.back();
                return 0
            }
            this.setState({
                results: window.history.state.results,
                listingCount: window.history.state.listingCount,
                modalIsOpen: window.history.state.modalIsOpen,
                itemKey: window.history.state.itemKey,
                url: window.history.state.url,
                changed: true
            });
            const detailItem = this.getDetailItemFromResults(this.state.results, this.state.itemKey);
            if (detailItem) { this.setState({item: detailItem, modalIsOpen: true}); }
        };
    }

    trackingEnabled = window.location.host.indexOf("realestate.") >= 0

    render() {
        const {affiliate, detailItemKey, defaultMapView, showAdTile} = this.windowInfo;
        const reportingServerPath = this.trackingEnabled
                                        ? '//report-re.' + this.fullName + '.com/images/mdwtc/'
                                        : '//morrisreporting-s3.f5-prod.r53.advance.net/images/mdwtc/';
        const urlParams = getUrlParams();

        const {filters, results, changed, modalIsOpen, floorplanModalIsOpen, floorplanURL,
            shareModalIsOpen, mapSearch, listingCount, showMap, maxResults, page } = this.state;
        const addlResultsCount = results
            ? Math.min(maxResults,
                results._discovery.response.hits.total.value - results._discovery.request.from - maxResults)
            : 0;
        const stateUrlParams = this.getStateUrlParams();
        return (
        <div className="srp">
            <link href="https://www.nj.com/pb/resources/dist/nj/css/defaulta6d07b66427ea7ed3f05.css" type="text/css"/>
            <SearchForm
                affiliate={affiliate}
                defaultMapView={showMap}
                sendQuery={(newFilters, callback) => {
                    this.setState({filters: newFilters});
                    this.getResults(callback);
                    }}
                stateUrlParams={stateUrlParams}
                getUrlParams={getUrlParams}
                page={page}
                maxResults={maxResults}
                changed={changed}
                searchUI={this.searchUI}
            />
            <div className="status-bar">
                <div className="listing-count">{listingCount}</div>
                <Toggle id="map-list-toggle"
                    onText="Show list"
                    offText="Show map"
                    defaultStatus={showMap}
                    className="map-list-toggle"
                    callback={(newState) => {console.log("NEW TOGGLE STATE" + newState);
                            this.setState({showMap: newState})
                        }}
                />
            </div>
            <SrpBody
                affiliate={affiliate}
                results={results}
                filters={filters}
                mapSearch={mapSearch}
                setMapBounds={(bounds) => this.setState({viewStateMapBounds:bounds})}
                defaultMapView={showMap}
                reportingServerPath={reportingServerPath}
                getResults={this.getResults}
                openModalClick={this.clickModal}
                addlResultsCount={addlResultsCount}
                searchUI={this.searchUI}
                fullName={this.fullName}
                showAdTile={showAdTile}
                trackingEnabled={this.trackingEnabled}
            />
            <DetailModal
                affiliate={affiliate}
                fullName={this.fullName}
                isOpen={modalIsOpen}
                onRequestClose={this.clickModal}
                floorplanClick={this.clickFloorplanModal}
                shareClick={this.clickShareModal}
                item={this.state.item}
                reportingServerPath={reportingServerPath}
                trackingEnabled={this.trackingEnabled}
                priceRange={this.state.filters && this.state.filters.price_mm}
            />
            <FloorplanModal
                isOpen={floorplanModalIsOpen}
                onRequestClose={this.clickFloorplanModal}
                floorplanURL={floorplanURL}
            />
            <ShareModal
                item={this.state.item}
                trackingEnabled={this.trackingEnabled}
                isOpen={shareModalIsOpen}
                onRequestClose={this.clickShareModal}
            />
        </div>
        )
    }
}

class SrpBody extends Component {
    state = {
        filters: {},
        hoveredPin: null,
        hoveredPopup: null,
        results: null
    }
    getHits = () => {
        return this.props.results._discovery.response.hits.hits;};

    componentDidMount() {
    }
    componentDidUpdate() {
        // Check for new filters and update if they are found.
    }

    render() {
        const {results, openModalClick, affiliate, getResults, mapSearch, setMapBounds, defaultMapView,
            reportingServerPath, addlResultsCount, searchUI,fullName, showAdTile, trackingEnabled } = this.props;
        const {hoveredPin, hoveredPopup} = this.state;
        return (
        <div className="srp-body">
            <SrpList
                items={results ? this.getHits() : null}
                getResults={getResults}
                requestListingFrom={results ? results._discovery.request.from : null}
                totalListings={results ? results._discovery.response.hits.total.value : null}
                openModalClick={openModalClick}
                reportingServerPath={reportingServerPath}
                hoverPin={(pinId, popupId) => this.setState({hoveredPin: pinId, hoveredPopup: popupId})}
                hoveredPopup={hoveredPopup}
                addlResultsCount={addlResultsCount}
                searchUI={searchUI}
                showMap={defaultMapView}
                affiliate={fullName}
                affiliateShortName={affiliate}
                showAdTile={showAdTile}
                trackingEnabled={trackingEnabled}
            />
            <SrpMap
                affiliate={affiliate}
                items={results ? this.getHits() : []}
                centerCoords={null}
                widthDistance={null}
                mapSearch={mapSearch}
                setMapBounds={setMapBounds}
                getResults={getResults}
                openModalClick={openModalClick}
                defaultMapView={defaultMapView}
                hoveredPin={hoveredPin}
                hoveredPopup={hoveredPopup}
            />
            <div className="loader">
                <Loader
                    type="Oval"
                    color="#0088EE"
                    height="100"
                    width="100"
                />
            </div>
        </div>
        )
    }
}

export default App;
